import { PublicMoney, PublicPrice } from './miscellaneous';

export interface CartTotals {
  /** cart subtotal value, not including iba and so on .. */
  subtotal: PublicPrice;

  /** Interbank adjustment fee, applied when purchasing in a different currency */
  ibaFee?: PublicPrice;

  discount?: PricingDiscount;
  /** value voucher total price */
  valueVouchers?: PublicMoney;

  grand: PublicPrice;

  taxes: Tax[];

  taxtotal: PublicPrice;

  /** Deposit values and options to pay it (deposit + rest or full amount) */
  deposits?: CartDeposit[];

  discountTotal?: PublicMoney;
}

export interface PricingDiscount {
  name: string;
  amount: number;
  adjustmentType: string;
  discountType: string;
  priceAdjustmentAmount?: number;
  priceAdjustmentType?: string;
}

export interface CartDeposit {
  option: DepositOption;
  price: PublicMoney;
}

export enum DepositOption {
  DEPOSIT = 'pay-deposit',
  FULL = 'pay-full',
}

export interface Tax {
  name: string;
  amount: PublicMoney;
  amountPercent: number | null;
  type: TaxType;
}

export type TaxType =
  | 'percent'
  | 'perBooking'
  | 'perItem'
  | 'perAllocation'
  | 'perQuantity'
  | 'percentInitialCustomer';
